import { useContext, useEffect, useState } from 'react';

import { buildMetaUserData, propertiesForProduct, trackEvent } from 'lib/analytics';
import { UserContext } from 'context-providers/user-provider';
import { Product } from 'entities/product';

interface UsePdpProductViewedProps {
  products: Product[];
  sku: string;
}

export const usePdpProductViewed = ({
  products,
  sku,
}: UsePdpProductViewedProps) => {
  const { userState } = useContext(UserContext);
  const [selectedSku, setSelectedSku] = useState(sku);
  const product = products.find((prod) => prod.code === sku) || ({} as Product);

  useEffect(() => {
    if (product?.code) {
      (async () => {
        const userData = await buildMetaUserData(userState);
        trackEvent('Product Viewed', {
          ...propertiesForProduct(product),
          ...(userData ? { userData } : {}),
        });
      })();
    }
  }, []);

  return { selectedSku, setSelectedSku, product };
};
